import React, { useEffect, useState, useRef } from 'react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  const targetTime = useRef(new Date().getTime() + 24 * 60 * 60 * 1000);
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetTime.current - now;
      if (distance < 0) {
        clearInterval(interval);
        setTimeLeft({
          hours: 0,
          minutes: 0,
          seconds: 0
        });
        return;
      }
      const hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      const minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(distance % (1000 * 60) / 1000);
      setTimeLeft({
        hours,
        minutes,
        seconds
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="bg-gold text-black py-2.5 px-4 text-center z-[60] relative font-bold text-xs tracking-wide uppercase" data-id="element-311">
      <span className="hidden sm:inline" data-id="element-312">
        🔥 Launch offer: 47% OFF · Ends in{' '}
      </span>
      <span className="sm:hidden" data-id="element-313">🔥 47% OFF · Ends in </span>
      <span className="font-display tracking-tight text-sm ml-1" data-id="element-314">
        {formatTime(timeLeft.hours)}:{formatTime(timeLeft.minutes)}:
        {formatTime(timeLeft.seconds)}
      </span>
    </div>;
}